import { render, staticRenderFns } from "./AddEventDescription.vue?vue&type=template&id=43e3c62a&"
import script from "./AddEventDescription.vue?vue&type=script&lang=js&"
export * from "./AddEventDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddEventDescription.vue"
export default component.exports